import { render, staticRenderFns } from "./ModalFieldConfig.vue?vue&type=template&id=b58cb088&scoped=true&"
import script from "./ModalFieldConfig.vue?vue&type=script&lang=js&"
export * from "./ModalFieldConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalFieldConfig.vue?vue&type=style&index=0&id=b58cb088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58cb088",
  null
  
)

export default component.exports